import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { ActionLink } from "@/components/common/actions/actions.component";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import type { ShoppingGuideCardProps } from "./shopping-guide-card.types";

/**
 * ShoppingGuideCard Component
 *
 * A presentational card for an individual shopping guide. Displays a full-bleed
 * image with a gradient overlay from transparent to dark at the bottom, with
 * headline text anchored over the gradient.
 *
 * **Desktop (>=tablet):** Portrait card (aspect-ratio 421/535).
 * **Mobile (<tablet):** Full-width card maintaining the same aspect ratio.
 *
 * On hover the image scales up slightly for a subtle zoom effect.
 */
export function ShoppingGuideCard(t0) {
  const $ = _c(12);
  const {
    headline,
    slug,
    visual,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("group relative block aspect-[421/535] w-full overflow-hidden rounded-sm", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== visual) {
    t2 = visual && <VisualWrapper visual={visual} className="absolute inset-0 size-full transition-transform duration-300 ease-out group-hover:scale-105" visualClassName="size-full" imgClassName="object-cover" extraImageProps={{
      visualOrientation: "0"
    }} />;
    $[2] = visual;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent from-[60%] to-black/60" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== headline) {
    t4 = <div className="absolute inset-x-0 bottom-0 z-10 p-6"><h3 className="typography-mobile-heading-h5 tablet:typography-desktop-heading-h5 text-white">{headline}</h3></div>;
    $[5] = headline;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== slug || $[8] !== t1 || $[9] !== t2 || $[10] !== t4) {
    t5 = <ActionLink slug={slug} className={t1} data-testid="shopping-guide-card">{t2}{t3}{t4}</ActionLink>;
    $[7] = slug;
    $[8] = t1;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}